export default __webpack_public_path__ + "static/media/Tardid Logo.c0f8428b.JPG";